import React, { useState } from "react";
import FeeProrataCard from "../FeeProrataCard/FeeProrataCard";
import "react-bootstrap";

const ProrataComponent = ({ header, list }) => {
  const [showmore, setShowmore] = useState(false);
  const handleShowmore = () => {
    setShowmore(!showmore);
  };

  return (
    <div>
      <div className="investmentProrateList" style={{ marginTop: "40px" }}>
        <div className="FeeInvestmentDropDown">
          <p className="addedPlans-card-font">
            {header} - {list.length}
          </p>
          {list.length > 3 && (
            <p onClick={handleShowmore} className="FeeInvesmentShowmoreBtn">
              {list.length > 3 &&
                (!showmore
                  ? `+${list.length - 3} More `
                  : `+${list.length - 3} Hide `)}
            </p>
          )}
        </div>
        <div
          style={{
            border: "0.05px solid rgba(0,0,0,0.1)",
            margin: "5px 0 10px 0",
          }}
        ></div>
        <div>
          {showmore
            ? list.map((item, index) => <FeeProrataCard name={item.name} />)
            : list
                .slice(0, 3)
                .map((item) => <FeeProrataCard name={item.name} />)}
        </div>
      </div>
    </div>
  );
};

export default ProrataComponent;
